import styled from "styled-components"
import { rem } from "@mantine/core"

import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"
import { getFontColorForBackgroundContrast } from "QuorumGrassroots/styled-components/helperFunctions"

export const StyledPACBanner = styled.div`
    display: flex;
    align-items: center;
`

export const StyledPACText = styleWithOrgDesign(styled.span`
    color: ${(props) => getFontColorForBackgroundContrast(props.organizationDesign.primary_color)};
    font-size: ${(props) => rem(14)};
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    line-height: ${(props) => rem(20)};
    letter-spacing: ${(props) => rem(0.25)};
    margin: 0;
`)
